import React from 'react';

import { Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { TextVariant } from 'common/components';
import CardContainer from 'common/components/CardContainer';
import { ReactHookFormIntlNumberInput } from 'common/components/form/RHF';
import * as productDatasheetSelectors from 'common/modules/productDatasheet/selectors';
import * as productThumbnailSelectors from 'common/modules/productThumbnail/selectors';

import * as selectors from '../selectors';

const ElectricalParameters = ({
    control,
    isEnabledEdition,
    isFetchingDetail,
    isLoadingProductDatasheet,
    isLoadingProductThumbnail,
    isSaving,
    isUploadingDatasheet,
    isUploadingThumbnail,
}) => {
    const { t } = useTranslation();

    const isLoading =
        isFetchingDetail ||
        isLoadingProductDatasheet ||
        isLoadingProductThumbnail ||
        isUploadingDatasheet ||
        isUploadingThumbnail ||
        isSaving;

    return (
        <CardContainer
            title={t('Parameters')}
            isCollapsable
            isOpen
            loading={isFetchingDetail}
            withDivider
        >
            <div>
                <TextVariant
                    text={t('General data')}
                    separatorLeft
                    color="#525252"
                    fontSize="16px"
                    fontWeight="600"
                />

                <Grid container pt={2}>
                    <Grid size={{ md: 9, xs: 18 }}>
                        <ReactHookFormIntlNumberInput
                            append="mm"
                            control={control}
                            disabled={!isEnabledEdition || isLoading}
                            fullWidth
                            label={t('Width')}
                            name="width"
                            placeholder={t('Width')}
                            required
                        />
                    </Grid>

                    <Grid size={{ md: 9, xs: 18 }}>
                        <ReactHookFormIntlNumberInput
                            append="mm"
                            control={control}
                            disabled={!isEnabledEdition || isLoading}
                            fullWidth
                            label={t('Height')}
                            name="height"
                            placeholder={t('Height')}
                            required
                        />
                    </Grid>

                    <Grid size={{ md: 9, xs: 18 }}>
                        <ReactHookFormIntlNumberInput
                            append="mm"
                            control={control}
                            disabled={!isEnabledEdition || isLoading}
                            fullWidth
                            label={t('Depth')}
                            name="depth"
                            placeholder={t('Depth')}
                            required
                        />
                    </Grid>

                    <Grid size={{ md: 9, xs: 18 }}>
                        <ReactHookFormIntlNumberInput
                            append="Kg"
                            control={control}
                            disabled={!isEnabledEdition || isLoading}
                            fullWidth
                            label={t('Weight')}
                            name="weight"
                            placeholder={t('Weight')}
                            required
                        />
                    </Grid>
                </Grid>

                <Divider sx={{ my: 2 }} />

                <TextVariant
                    text={t('Electrical parameters')}
                    separatorLeft
                    color="#525252"
                    fontSize="16px"
                    fontWeight="600"
                />

                <Grid container pt={2}>
                    <Grid size={{ md: 9, xs: 18 }}>
                        <ReactHookFormIntlNumberInput
                            append="w"
                            control={control}
                            disabled={!isEnabledEdition || isLoading}
                            fullWidth
                            label={t('Maximum power')}
                            name="max_power"
                            placeholder={t('Maximum power')}
                            required
                        />
                    </Grid>
                </Grid>
            </div>
        </CardContainer>
    );
};

ElectricalParameters.propTypes = {
    control: PropTypes.object,
    isEnabledEdition: PropTypes.bool,
    isFetchingDetail: PropTypes.bool,
    isLoadingProductDatasheet: PropTypes.bool,
    isLoadingProductThumbnail: PropTypes.bool,
    isSaving: PropTypes.bool,
    isUploadingDatasheet: PropTypes.bool,
    isUploadingThumbnail: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
    isEnabledEdition: selectors.getEnabledEdition,
    isFetchingDetail: selectors.getIsFetchingItemDetail,
    isLoadingProductDatasheet:
        productDatasheetSelectors.getIsLoadingProductDatasheet,
    isLoadingProductThumbnail:
        productThumbnailSelectors.getIsLoadingProductThumbnail,
    isSaving: selectors.getIsSaving,
    isUploadingDatasheet: productDatasheetSelectors.getIsUploadingDatasheet,
    isUploadingThumbnail: productThumbnailSelectors.getIsUploadingThumbnail,
});

export default connect(mapStateToProps, null)(ElectricalParameters);
